/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import type { LocationSchools } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import { RECEIVE_LOCATION_SCHOOLS } from '../constants/index'

export const receiveLocationSchools = createAction<
  LocationSchools,
  typeof RECEIVE_LOCATION_SCHOOLS
>(RECEIVE_LOCATION_SCHOOLS)
